import { Tooltip } from "antd";
import styles from "../styles/ui/RadarIcon.module.css";

const RadarIcon = () => {
  return (
    <Tooltip
      color="#0c4cfc"
      title="New signals are generated every 5 minutes. Stay on this page to avoid missing out."
    >
      <div className={styles.radar}>
        <div className={styles.pulse}></div>
        <div className={styles.pulse}></div>
        <div className={styles.pulse}></div>
      </div>
    </Tooltip>
  );
};
export default RadarIcon;
